import hemllin from '../../assets/project/Hemllin.jpeg';
import movierex from '../../assets/project/movierex.jpeg';
import speciappt from '../../assets/project/userHome.jpeg';
import coffeeconnect from '../../assets/project/coffeeconnect.jpeg';
import payd_test from '../../assets/project/payd_test.jpeg';

const projectList = [
    {
        id: 1,
        title: "Management Consultancy Firm -Hemllin",
        imgSrc: hemllin,
        description: 'The Management Consultancy Firm Website project is a dynamic and modern web platform designed to elevate the online presence of a leading consultancy firm. This comprehensive web solution offers an array of features tailored to meet the needs of both the consultancy firm and its clients',
        code: 'https://github.com/joykara/Hemllin-master',
        link:'https://hemllin-master.vercel.app/'
    },
    {
        id: 2,
        title: "Movierex",
        imgSrc: movierex,
        description: 'Movierex is a dynamic and modern movie recommendation platform designed to allow users to brose through a collection of movies. This application allows the user to view comprehensive details about each movie including: ratings, release dates, genres, and cast information etc',
        code: 'https://github.com/joykara/movie-app',
        link:'https://movie-app-peach-eight-75.vercel.app/'
    },
    {
        id: 3,
        title: "SpeciAppt",
        imgSrc: speciappt,
        description: 'SpeciAppt is a dynamic and modern web platform designed to aid in scheduling and booking appointments. Leveraging the power of the MERN stack—MongoDB, Express.js, React, and Node.js—this comprehensive web solution offers an array of features tailored to meet the needs of both the patients and doctors',
        code: 'https://github.com/joykara/SpeciAppt',
        link:'https://speci-appt.vercel.app/'

    },
    {
        id: 4,
        title: "Post Management Interface",
        imgSrc: payd_test,
        description: 'The Post Management Interface is a user-friendly React application that interacts seamlessly with an API to manage posts. It allows users to fetch and view posts, create new posts, and includes a search functionality to filter posts efficiently, enhancing user experience.',
        code: 'https://github.com/joykara/payd-intern-assessment/tree/master/payd-test',
        // link: 'https://post-management-interface.vercel.app/'
    },
    {
        id: 5,
        title: "Coffee Connection",
        imgSrc: coffeeconnect,
        description: 'Coffee Connection is an engaging landing page designed to elevate the online presence of a coffee shop. This comprehensive web solution offers an array of features tailored to meet the needs of both the coffee shop and its clients showcasing some of the drinks offered.',
        code: 'https://github.com/joykara/cafe-website',
        link: 'https://cafe-website-nine.vercel.app/'
    }
]

export default projectList
